import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';

import PollModel from '../list/poll';
import PollFolder from '../list/poll-folder';
import PollQuestion from '../list/poll-question';
import PollAnswers from '../list/poll-answers';
import PollRights from '../list/poll-rights';

import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';

const API_PATH_POLLS = 'polls';
const API_PATH_FOLDERS = 'poll-folders';
const API_PATH_QUESTIONS = 'poll-questions';
const API_PATH_ANSWERS = 'poll-answers';
const API_PATH_POLLS_FALE = 'polls/fake';
const API_PATH_POLL_RIGHTS = 'poll-event-rights';

export const PollsManager = {
  objects: objectsRHandler(API_PATH_POLLS, PollModel),
  fake: objectsRHandler(API_PATH_POLLS_FALE, PollModel),
  folders: objectsRHandler(API_PATH_FOLDERS, PollFolder),
  get questions() {
    const path = API_PATH_QUESTIONS;
    return {
      ...objectsRHandler(path, PollQuestion),

      /**
     * @param {Object} { sort: {question_id, sort_order}[]] }
     * @returns response
     */
      setSort({ data } = DEFAULT_PARAMS) {
        return rHandler(
          apiService.post(`/${path}/sort-order`, data),
          (response) => ({ response }),
          (error) => ({ error }),
        );
      },
    };
  },
  get answers() {
    const path = API_PATH_ANSWERS;
    return {
      ...objectsRHandler(path, PollAnswers),
    };
  },
  rights: objectsRHandler(API_PATH_POLL_RIGHTS, PollRights),
};
